export default {
  modelName: 'cms_log',
  versionModelName: 'act_version',
  versionTimestampKey: 'announce_at',
  label: '後台活動紀錄',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    payload: {
      type: 'payload',
      label: '版本列表',
      modelName: 'payload',
      fields: {
        userModelName: {
          type: 'text',
          label: '使用者名稱',
          rules: 'required',
        },
        user_id: {
          type: 'text',
          label: '使用者 ID',
          rules: 'required',
        },
        action: {
          type: 'text',
          label: '更新紀錄',
          rules: 'required',
        },
        target: {
          type: 'text',
          label: '詳細內容',
          rules: 'required',
        },
        target_id: {
          type: 'text',
          label: '公版 ID',
          rules: 'required',
        },
        ip: {
          type: 'text',
          label: 'IP 位置',
          rules: 'required',
        },
        status: {
          type: 'select',
          label: '狀態',
          items: [
            {
              value: 0,
              text: '失敗',
            },
            {
              value: 1,
              text: '成功',
            },
          ],
          defaultValue: 0,
        },
      },
    },
    admin: {
      type: 'admin',
      label: '使用者',
      modelName: 'admin',
      fields: {
        name: {
          type: 'text',
          label: '使用者名稱',
          rules: 'required',
        },
      },
    },
    updated_at: {
      type: 'datetime',
      label: '日期時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    name: {
      type: 'text',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '詳細內容',
      readonly: true,
      getValue: (item) => {
        let _value = item.payload.action;
        if (item.payload.target) {
          _value += `  ${item.payload.target}`;
        }
        if (item.payload.target_id) {
          _value += `  ${item.payload.target_id}`;
        }
        return _value;
      },
    },
  },
};
